module.exports = __webpack_public_path__ + "img/onboarding_icon_2.6fb04842.svg";